import api, { ApiCallReturn } from "../api";

export const initDeposit = (method: string, quantity: number): ApiCallReturn => api.post('/transaction-wallet/user/deposit/init', {method, quantity});
